import { faAnchor, faColumns } from "@fortawesome/free-solid-svg-icons";
import ToolbarButton from "../../../components/ToolbarButton";
import { INSERT_MEDIA_COMMAND } from "../../MediaPlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { INSERT_LAYOUT_COMMAND } from "../../LayoutPlugin/LayoutPlugin";
import ModalWithFinalForm from "../../../../modals/ModalWithFinalForm";
import { Row } from "reactstrap";
import { SetStateAction, useState } from "react";
import FormFieldTextOrNumber from "../../../../formFields/FormFieldTextOrNumber";
import { useIntl } from "react-intl";
import FormFieldWithDropdown from "../../../../formFields/FormFieldWithDropdown";

export const LAYOUTS =
[
    { label: '2 columns (equal width)', id: '1fr 1fr' },
    { label: '2 columns (25% - 75%)', id: '1fr 3fr' },
    { label: '3 columns (equal width)', id: '1fr 1fr 1fr' },
    { label: '3 columns (25% - 50% - 25%)', id: '1fr 2fr 1fr' },
    { label: '4 columns (equal width)', id: '1fr 1fr 1fr 1fr' },
];

export function Layout()
{
    const [editor] = useLexicalComposerContext();
    const intl = useIntl();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [value, setValue] = useState(LAYOUTS[0].id);
    const handleSubmit = () =>
    {
        editor.dispatchCommand(INSERT_LAYOUT_COMMAND, value);
        setIsModalOpen(false);
    };
    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.columnsModal;
    const buttons =
    {
        confirm: { color: 'success', label: translations?.confirm ?? 'OK' },
        cancel: { color: 'danger', label: translations?.cancel ?? 'Cancel' }
    };
    const options = LAYOUTS.map(({ label, id }) => ({ label: translations?.values?.[id] ?? label, id }));
    const element =
    <>
        <button type="button" className="btn" onClick={() => setIsModalOpen(true)}>
            <FontAwesomeIcon icon={faColumns} />
        </button>
        {isModalOpen && <ModalWithFinalForm isOpen={isModalOpen} initialValues={{ value, layout: value }}
            setIsOpen={setIsModalOpen}
            onConfirm={handleSubmit}
            header={translations?.header ?? 'Column Layout'}
            buttons={buttons}
            modalBody=
            {<>
                {/* <Alert color='danger' isOpen={isAlertOpen} toggle={() => setIsAlertOpen(false)} >
                    <span>{alertMessage}</span>
                </Alert> */}
                <Row className='my-2 d-flex flex-column '>
                    <FormFieldWithDropdown label={translations?.layoutName ?? 'Name'} name={'layout'} options={options} onDropdownChange={(value: string) => setValue(value)} />
                </Row>
                <Row className='my-2'>
                    <FormFieldTextOrNumber type='text' className="w-100" name='value' label={translations?.layoutValue ?? 'Definition'} />
                </Row>
            </>}
        />}
    </>;
    return element;
}